import React from 'react';

interface ErrorMessageProps {
  message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  return (
    <div
      style={{
        color: '#d9534f',
        backgroundColor: '#f8d7da',
        border: '1px solid #f5c6cb',
        borderRadius: '4px',
        padding: '10px',
        marginTop: '10px',
        fontSize: '14px',
      }}
    >
      <strong>Error:</strong> {message}
    </div>
  );
};

export default ErrorMessage;
